import styled from "styled-components";
import { motion } from "framer-motion";

export const Container = styled.div`
  max-width: 1440px;
  margin: 0 auto;
  padding: 2rem;
  background: #f8fafc;
  min-height: 100vh;
`;

export const Header = styled.div`
  background: #1e40af;
  color: white;
  padding: 1.5rem;
  display: flex;
  align-items: center;
  gap: 0.75rem;
  
  h2 {
    margin: 0;
    font-size: 1.25rem;
  }
`;

export const Body = styled.div`
  padding: 2rem;
`;

export const QuestionCard = styled.div`
  background: white;
  border-radius: 0.5rem;
  padding: 1.5rem;
  margin-bottom: 1rem;
  border: 1px solid #e2e8f0;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
`;

export const RadioGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
  margin-top: 1rem;

  label {
    display: flex;
    align-items: center;
    gap: 0.5rem;
    cursor: pointer;
  }

  input[type="radio"] {
    cursor: pointer;
  }
`;

export const CheckboxGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
  margin-top: 1rem;

  label {
    display: flex;
    align-items: center;
    gap: 0.5rem;
    cursor: pointer;
  }

  input[type="checkbox"] {
    cursor: pointer;
  }
`;



export const LoadingOverlay = styled(motion.div)`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(255, 255, 255, 0.9);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 1.5rem;
  z-index: 1500;

  .spinning {
    animation: spin 1.2s linear infinite;
    color: #3b82f6;
    font-size: 2rem;
  }

  p {
    font-size: 1.5rem;
    font-weight: bold;
    color: #1e40af;
    text-align: center;
  }

  @keyframes spin {
    from {
      transform: rotate(0deg);
    }
    to {
      transform: rotate(360deg);
    }
  }
`;


export const Label = styled.label`
  display: block;
  margin-bottom: 0.5rem;
  color: #334155;
  font-weight: 500;
`;

export const Error = styled.p`
  color: #ef4444;
  font-size: 0.875rem;
  margin-top: 0.5rem;
`;

export const SuggestedCard = styled.div`
  background: #fffbeb;
  border: 1px solid #fcd34d;
  border-radius: 0.5rem;
  padding: 1rem;
  margin-bottom: 1rem;
`;


export const ButtonGroup = styled.div`
  display: flex;
  gap: 1rem;
  margin-top: 2rem;
`;

export const Button = styled(motion.button)`
  padding: 0.75rem 1.5rem;
  border-radius: 0.5rem;
  font-weight: 500;
  border: none;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 0.5rem;
  
  ${props => props.variant === 'primary' && `
    background: #1e40af;
    color: white;
    
    &:hover:not(:disabled) {
      background: #1e3a8a;
    }
  `}
  
  ${props => props.variant === 'secondary' && `
    background: #e2e8f0;
    color: #475569;
    
    &:hover:not(:disabled) {
      background: #cbd5e1;
    }
  `}
`;

export const FormGroup = styled.div`
  margin-bottom: 1.5rem;
`;

export const SummaryCard = styled.div`
  background: white;
  border-radius: 0.5rem;
  padding: 1.5rem;
  margin-bottom: 1rem;
  border: 1px solid #e2e8f0;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);

  h3 {
    margin: 0 0 1rem 0;
    color: #1e40af;
    font-size: 1.125rem;
  }

  p {
    margin: 0.5rem 0;
    color: #475569;
  }

  ${props => props.status === 'success' && `
    border-color: #86efac;
    background: #f0fdf4;
  `}

  ${props => props.status === 'warning' && `
    border-color: #fcd34d;
    background: #fffbeb;
  `}

  ${props => props.status === 'error' && `
    border-color: #fca5a5;
    background: #fef2f2;
  `}
`;
export const LinkList = styled(motion.div)`
  background: white;
  border-radius: 1rem;
  padding: 1.5rem;
  margin-bottom: 1rem;
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1);

  h3 {
    color: #1e40af;
    margin: 0 0 1rem 0;
  }

  a {
    display: flex;
    align-items: center;
    gap: 0.5rem;
    color: #2563eb;
    text-decoration: none;
    padding: 0.75rem;
    border-radius: 0.5rem;
    transition: all 0.2s ease-in-out;
    margin-bottom: 0.5rem;

    &:hover {
      background: #f1f5f9;
      text-decoration: underline;
    }

    &:last-child {
      margin-bottom: 0;
    }
  }
`;


export const DriverList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
  margin: 1rem 0;

  .driver-item {
    display: flex;
    align-items: center;
    gap: 1rem;
    padding: 1rem;
    background: #f8fafc;
    border-radius: 0.5rem;
    border: 1px solid #e2e8f0;

    .driver-info {
      flex: 1;

      h4 {
        margin: 0 0 0.25rem 0;
        color: #1e40af;
      }

      p {
        margin: 0;
        color: #64748b;
        font-size: 0.875rem;
      }
    }

    .driver-rating {
      display: flex;
      align-items: center;
      gap: 0.25rem;
      color: #eab308;
    }
  }
`;

export const StatusIndicator = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.5rem 1rem;
  border-radius: 9999px;
  font-size: 0.875rem;
  font-weight: 500;

  ${props => {
    switch (props.status) {
      case 'LOADING':
        return `
          background: #f1f5f9;
          color: #475569;
        `;
      case 'FOUND':
        return `
          background: #dcfce7;
          color: #166534;
        `;
      case 'NONE':
        return `
          background: #fee2e2;
          color: #991b1b;
        `;
      default:
        return `
          background: #f1f5f9;
          color: #475569;
        `;
    }
  }}

  svg {
    animation: ${props => props.status === 'LOADING' ? 'spin 1s linear infinite' : 'none'};
  }

  @keyframes spin {
    from {
      transform: rotate(0deg);
    }
    to {
      transform: rotate(360deg);
    }
  }
`;

export const VehicleCard = styled(motion.div)`
  background: white;
  border-radius: 1rem;
  padding: 1.5rem;
  margin-bottom: 1rem;
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1);
  border: 2px solid #e2e8f0;
  transition: all 0.2s ease-in-out;
  cursor: pointer;

  &:hover {
    border-color: #1e40af;
    transform: translateY(-2px);
    box-shadow: 0 8px 20px rgba(0, 0, 0, 0.15);
  }

  label {
    cursor: pointer;
    display: flex;
    align-items: flex-start;
    gap: 1rem;
    width: 100%;
    
    input[type="radio"] {
      cursor: pointer;
      margin-top: 0.25rem;
    }
    
    .details {
      flex: 1;
      
      h4 {
        margin: 0 0 0.5rem 0;
        color: #1e293b;
        font-size: 1rem;
        font-weight: 600;
      }
      
      p {
        margin: 0.25rem 0;
        color: #64748b;
        font-size: 0.9rem;
        display: flex;
        align-items: center;
        gap: 0.5rem;
        
        svg {
          color: #1e40af;
        }
      }
    }
  }

  .vehicle-header {
    display: flex;
    align-items: center;
    gap: 1rem;
    margin-bottom: 1rem;

    svg {
      color: #1e40af;
    }

    h3 {
      margin: 0;
      color: #1e293b;
      flex: 1;
    }
  }

  .vehicle-details {
    display: flex;
    flex-direction: column;
    gap: 0.75rem;

    p {
      margin: 0;
      color: #64748b;
      display: flex;
      align-items: center;
      gap: 0.5rem;

      svg {
        color: #1e40af;
      }
    }
  }
`;

export const RecommendedVehicleCard = styled(VehicleCard)`
  border: 2px solid #f59e0b;
  background: linear-gradient(135deg, #fffbeb 0%, #fef3c7 100%);
  border-radius: 16px;
  padding: 2rem;
  position: relative;
  overflow: hidden;
  box-shadow: 0 8px 25px rgba(0, 0, 0, 0.12);
  transition: all 0.3s ease;

  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    height: 4px;
    background: linear-gradient(90deg, #f59e0b, #d97706);
  }

  .header {
    display: flex;
    align-items: center;
    gap: 0.75rem;
    margin-bottom: 1.5rem;

    svg {
      color: #d97706;
    }

    h3 {
      margin: 0;
      color: #92400e;
      font-size: 1.125rem;
      font-weight: 600;
    }
  }

  label {
    display: flex;
    align-items: flex-start;
    gap: 1rem;
    cursor: pointer;
    background: white;
    border: 2px solid #d97706;
    border-radius: 12px;
    padding: 1rem 1.25rem;
    transition: all 0.2s ease;
    
    &:hover {
      background: #fef3c7;
      border-color: #b45309;
    }
    
    input[type="radio"] {
      margin-top: 0.25rem;
      cursor: pointer;
    }
    
    .details {
      flex: 1;
      
      h4 {
        margin: 0 0 0.5rem 0;
        color: #92400e;
        font-size: 1rem;
        font-weight: 600;
        display: flex;
        align-items: center;
        gap: 0.5rem;
      }
      
      p {
        margin: 0.25rem 0;
        color: #92400e;
        font-size: 0.9rem;
        display: flex;
        align-items: center;
        gap: 0.5rem;
      }
    }
  }

  &:hover {
    border-color: #d97706;
    transform: translateY(-2px);
    box-shadow: 0 12px 30px rgba(0, 0, 0, 0.15);
  }
`;


export const FormSection = styled(motion.div)`
  background: white;
  border-radius: 1rem;
  box-shadow: 0 4px 6px -1px rgb(0 0 0 / 0.1);
  overflow: hidden;
  position: relative;
  height: fit-content;
  min-height: 600px;

  @media (max-width: 1024px) {
    margin-bottom: 2rem;
  }

  // If you want to add a max-height and scrolling
  max-height: calc(100vh - 4rem);
  overflow-y: auto;

  // Custom scrollbar styling
  &::-webkit-scrollbar {
    width: 8px;
  }

  &::-webkit-scrollbar-track {
    background: #f1f5f9;
  }

  &::-webkit-scrollbar-thumb {
    background: #cbd5e1;
    border-radius: 4px;
  }

  &::-webkit-scrollbar-thumb:hover {
    background: #94a3b8;
  }
`;

export const MapSection = styled(motion.div)`
  border-radius: 1rem;
  overflow: hidden;
  box-shadow: 0 4px 6px -1px rgb(0 0 0 / 0.1);
  background: white;
  position: relative;
  height: 600px; // Fixed height for the map

  @media (max-width: 1024px) {
    height: 400px; // Smaller height on mobile devices
  }

  // Loading state overlay (optional)
  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(255, 255, 255, 0.8);
    z-index: 1;
    display: ${props => props.isLoading ? 'block' : 'none'};
  }

  // Map container styling
  .map-container {
    width: 100%;
    height: 100%;
  }

  // Controls styling (if needed)
  .map-controls {
    position: absolute;
    top: 1rem;
    right: 1rem;
    z-index: 2;
    display: flex;
    flex-direction: column;
    gap: 0.5rem;

    button {
      background: white;
      border: none;
      border-radius: 0.5rem;
      padding: 0.5rem;
      box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
      cursor: pointer;
      display: flex;
      align-items: center;
      justify-content: center;

      &:hover {
        background: #f8fafc;
      }
    }
  }

  // Route info styling (if needed)
  .route-info {
    position: absolute;
    bottom: 1rem;
    left: 1rem;
    right: 1rem;
    background: white;
    padding: 1rem;
    border-radius: 0.5rem;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
    z-index: 2;

    display: ${props => props.showRouteInfo ? 'block' : 'none'};
  }
`;


export const Grid = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 2rem;
  
  @media (max-width: 1024px) {
    grid-template-columns: 1fr;
  }
`;


export const EmergencyDetailsCard = styled(motion.div)`
  background: white;
  border-radius: 1rem;
  padding: 1.5rem;
  margin-bottom: 1.5rem;
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1);

  .severity-section {
    margin-bottom: 1.5rem;
    
    h3 {
      color: #1e40af;
      margin-bottom: 0.5rem;
    }
  }

  .route-details {
    display: flex;
    flex-direction: column;
    gap: 1rem;
    padding: 1rem 0;
    border-top: 1px solid #e2e8f0;

    .location {
      display: flex;
      align-items: flex-start;
      gap: 0.75rem;

      svg {
        color: #1e40af;
        margin-top: 0.25rem;
      }

      div {
        small {
          color: #64748b;
          font-size: 0.875rem;
        }

        p {
          margin: 0;
          color: #1e293b;
          font-weight: 500;
        }
      }
    }
  }
`;



export const PriceTag = styled.div`
  display: flex;
  align-items: center;
  gap: 0.25rem;
  background: #f0f9ff;
  padding: 0.5rem 0.75rem;
  border-radius: 0.5rem;
  color: #1e40af;
  font-weight: 600;

  svg {
    color: #1e40af;
  }
`;



export const DistanceIndicator = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5rem;
  margin-top: 1rem;
  padding-top: 1rem;
  border-top: 1px solid #e2e8f0;
  color: #64748b;

  svg {
    color: #1e40af;
  }

  span {
    font-weight: 500;
  }
`;
